import { Component, OnInit, NgZone, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';

import ProductUtils from '../product-utils';
import { TmProductForPRP, TmProduct } from '../tscapi/model/product';
import { TmShowModel } from '../tscapi/model/show';
import { TscAPI } from '../tscapi/service/tscapi.service';
import { CommonUtils } from '../utils/common-utils';
import { Cookie } from '../utils/cookie';

import { TranslateService } from './translate/index';

declare let pwr: any;
declare global {
    interface Window {
        pwr: any;
    }
}
const lang: string = new Cookie().Language;


export class WatchUsLive implements OnInit, AfterViewInit, AfterViewChecked {
    public imageBaseUrl = 'https://item.tscimg.ca/TSC/';
    public liveShow: TmShowModel;

    public products: TmProductForPRP[];
    public watchusliveProducts: TmProductForPRP[];
    public watchusliveProductsFiltered: TmProductForPRP[];
    public productTypes: string[];
    public selectedProductType = 'Select';

    public liveProduct: TmProductForPRP;
    public futureProducts: TmProductForPRP[];
    public PreviousPageProducts: TmProductForPRP[];
    public endTimeSlot: string;
    public prpSwatches: string[];
    public prpSwatchesExist: string[] = [];
    public selectedTimeZone = '';

    reviewSnippetArray = [];
    public reviewsRendered = false;

    constructor(
        private _translate: TranslateService,
        private cookie: Cookie,
        private tscAPI: TscAPI,
    ) {
        this._translate.use(new Cookie().Language);
    }
    private isConsentCategoryDisabled(category: string): boolean {
        if (typeof category === 'undefined') {
            console.info('Consent category not specified!');
            return true;
        }
        category = category.toLocaleLowerCase();
        let disabled = false;
        if (typeof window.rogers === 'object' && typeof window.rogers.consent === 'object') {
            if (
                typeof window.rogers.consent[category] === 'undefined' ||
                (typeof window.rogers.consent[category] === 'boolean' && window.rogers.consent[category] === false)
            ) {
                disabled = true;
                // console.info("EU/CA/QC user consent['" + category + "'] disabled.");
            }
        }
        return disabled;
    }
    ngOnInit(): void {
        this.refreshProductData();
    }

    ngAfterViewInit(): void {}

    ngAfterViewChecked(): void {
        if (
            this.watchusliveProductsFiltered != null &&
            this.watchusliveProductsFiltered.length > 0 &&
            !this.reviewsRendered
        ) {
            this.renderReviewSnippet();
        }
    }

    filterProducts(): void {
        this.watchusliveProductsFiltered = [];
        const obj = this;
        if (this.selectedProductType != '' && this.selectedProductType != 'Select') {
            $(this.watchusliveProducts).each(function () {
                if ((<any>this).ProductType == obj.selectedProductType) {
                    obj.watchusliveProductsFiltered.push(<any>this);
                }
            });
        } else {
            this.watchusliveProductsFiltered = this.watchusliveProducts;
        }
        this.reviewsRendered = false;
        this.swatchModule();
    }

    refreshProductData(): void {
        function refreshProductDataCore(obj) {
            obj.loadTimeZone();
            obj.prpSwatches = null;
            obj.prpSwatchesExist = [];
            obj.tscAPI.watchUsLive.get(obj.selectedTimeZone).subscribe(
                (resp) => {
                    obj.products = resp.Products;
                    obj.liveShow = resp.LiveShow;

                    obj.endTimeSlot = obj.getEndTimeSlot();
                    if (obj.liveShow.Timeslot) obj.liveShow.Timeslot = obj.liveShow.Timeslot.substring(0, 5);

                    obj.SequenceProduct(obj.products);
                    //flag to trigger carouselScript

                    obj.populateCurrentShowHeader();
                },
                (error) => {
                    console.log(<any>error);
                },
            );
        }
        setInterval(() => {
            refreshProductDataCore(this);
        }, 600000); //Refreshing in 10 minutes.
        refreshProductDataCore(this);
    }

    getEndTimeSlot(): string {
        let startTime: string[];
        if (this.liveShow.Timeslot && this.liveShow.Timeslot.indexOf(':') > 0) {
            startTime = this.liveShow.Timeslot.split(':');
            let startHour: number = +startTime[0];
            const startMin: string = startTime[1];
            if (startMin == '30') startHour += 0.5;
            const endHour: number = startHour + this.liveShow.DurationInSeconds / 3600;
            let endTime: string[] = [];
            if ((endHour + '').indexOf('.') > 0) endTime = (endHour + '').split('.');
            else {
                endTime = [endHour + '', ''];
            }

            let endHourString: string = endTime[0];
            if (endHour < 10) endHourString = '0' + endHourString;
            const endMinString: string = endTime[1] == '5' ? '30' : '00';
            return endHourString + ':' + endMinString;
        } else {
            return null;
        }
    }

    findImageURL(product: TmProductForPRP): string {
        let imageURL = '';
        const defaultEdpIndex: number = product.Edps.findIndex((x) => x.EdpNo == product.DefaultEdp);
        if (defaultEdpIndex > -1) {
            product.EasyPaymentPrice = product.Edps[defaultEdpIndex].EasyPaymentPrice;
            imageURL = product.Edps[defaultEdpIndex].ImageUrl;
        }
        return imageURL != null ? imageURL : '';
    }

    SequenceProduct(sourceProducts: TmProductForPRP[]) {
        let previousItemNumber = '';
        let products: TmProductForPRP[] = [];
        this.watchusliveProducts = [];
        this.watchusliveProductsFiltered = [];
        this.productTypes = [];

        if (sourceProducts) {
            products = sourceProducts.sort(
                (p1, p2) => +new Date(p1.OnAirInfo.OnAirStart) - +new Date(p2.OnAirInfo.OnAirStart),
            );
        }

        for (const product of products) {
            //eleminating adjacent duplicacy
            if (product.ItemNo != previousItemNumber) {
                previousItemNumber = product.ItemNo;
                this.watchusliveProducts.push(product);
                if (this.productTypes.indexOf(product.ProductType) == -1) {
                    this.productTypes.push(product.ProductType);
                }
            }
        }
        this.productTypes = this.productTypes.sort();
        this.productTypes.unshift('Select');
        if (this.productTypes.indexOf(this.selectedProductType) == -1) this.selectedProductType = '';
        this.filterProducts();
    }
    loadTimeZone() {
        if (new Cookie().TimeZone === undefined) new Cookie().TimeZone = CommonUtils.getTimeZone();
        this.selectedTimeZone = new Cookie().TimeZone;
    }

    private populateCurrentShowHeader(): void {
        if (this.liveShow.Timeslot == null) {
            $('#watch-us-live-program-show-header span,#watch-us-live-program-show-header a').each(function () {
                $(this).text('');
            });
            console.log('liveShow values are not available');
            return;
        }
        const showTime = this.liveShow.Timeslot + ' - ' + this.endTimeSlot;
        const showTitle = this.liveShow.Name;
        let hostName, hostLink;
        if (this.liveShow.ShowHosts[0]) {
            hostName = this.liveShow.ShowHosts[0].Name;
            hostLink = this.liveShow.ShowHosts[0].NameForUrl;
        }

        $('#watch-us-live-program-show-header .programguide-showtime').text(showTime);
        $('#watch-us-live-program-show-header .programguide-show-title').text(showTitle);
        this.getLiveProduct();
        if (this.liveProduct) {
            $('#watch-us-live-program-show-header .programguide-show-title').attr(
                'href',
                '/pages/productdetails?nav=R:' + this.liveProduct.ItemNo,
            );
        }

        if (hostName) {
            $('#watch-us-live-program-show-header .text-with').text(' with ');
            $('#watch-us-live-program-show-header .with-guest').text(hostName);
            $('#watch-us-live-program-show-header .with-guest').attr('href', '/go/hosts/' + hostLink);
        } else {
            $('#watch-us-live-program-show-header .with-guest').text('');
        }
    }

    private getLiveProduct() {
        //For Testing - Remove
        //this.products[0].IsLive = true;

        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].IsLive) {
                this.liveProduct = this.products[i];
            }
        }
    }

    showWasPrice(product): boolean {
        return product.WasPriceRange !== product.IsPriceRange;
    }
    createRange(number: number) {
        return ProductUtils.createReviewStarRange(number);
    }
    swatchModule(): void {
        //build array of swatches
        const swatchArray = [];
        let tempArray = [];

        //dedupe the array
        function deDupeArray(inArray) {
            const cleanSwatchArray = [];
            $.each(inArray, function (i, el) {
                if ($.inArray(el, cleanSwatchArray) === -1) cleanSwatchArray.push(el);
            });
            return cleanSwatchArray;
        }

        if (this.watchusliveProductsFiltered != null && this.watchusliveProductsFiltered.length > 0) {
            for (let productsIndex = 0; productsIndex < this.watchusliveProductsFiltered.length; productsIndex++) {
                //loop through products
                tempArray = [];
                if (
                    this.watchusliveProductsFiltered[productsIndex].Edps != null &&
                    this.watchusliveProductsFiltered[productsIndex].Edps.length > 0
                ) {
                    for (
                        let edpIndex = 0;
                        edpIndex < this.watchusliveProductsFiltered[productsIndex].Edps.length;
                        edpIndex++
                    ) {
                        //loop through edps
                        let tempString =
                            '//item.tscimg.ca/TSC/' +
                            this.watchusliveProductsFiltered[productsIndex].Edps[edpIndex].ImageUrl;
                        tempString = tempString.replace('0x0/', '');
                        tempString = tempString.replace('.jpg', '_SW.jpg');
                        tempArray.push(tempString);
                    }
                    swatchArray.push(deDupeArray(tempArray));
                }
            }
        }

        this.prpSwatches = swatchArray;

        //test first swatch of each product
        for (let productSwatchIndex = 0; productSwatchIndex < this.prpSwatches.length; productSwatchIndex++) {
            //test first swatch
            this.getFirstSwatch(this.prpSwatches[productSwatchIndex], productSwatchIndex);
        }
    }

    getFirstSwatch(swatchURL, productSwatchIndex) {
        const self = this;
        function setExists(productSwatchIndex) {
            self.prpSwatchesExist[productSwatchIndex] = '1';
        }
        interface NewImage extends HTMLImageElement {
            callback: (...args: any[]) => void;
        }
        function createAImage(swatchURL): NewImage {
            return document.createElement('IMG') as NewImage;
        }
        const newImage = createAImage(swatchURL[0]);

        newImage.onload = function () {
            setExists(productSwatchIndex);
        };
        newImage.onerror = function () {
            return false;
        };
        newImage.src = swatchURL[0];
    }
    isFreeShipping(product) {
        const defaultEdp = product.DefaultEdp;
        const edps = product.Edps;
        if (defaultEdp && edps.length) {
            for (let i = 0; i < edps.length; i++) {
                if (edps[i].EdpNo == defaultEdp && edps[i].AppliedShipping == '') {
                    return true;
                }
            }
        }
        return false;
    }

    renderReviewSnippet() {
        this.reviewsRendered = true;
        this.reviewSnippetArray = [];
        const host = window.location.hostname;
        if (this.watchusliveProductsFiltered != null && this.watchusliveProductsFiltered.length > 0) {
            for (let i = 0; i < this.watchusliveProductsFiltered.length; i++) {
                const product: TmProductForPRP = this.watchusliveProductsFiltered[i];
                if (product != null && product.ProductReviewCount > 0) {
                    //clear existing reviews
                    document.getElementById('product-reviewsnippet-' + product.ItemNo).innerHTML = '';
                    this.buildSnippetArray(product.ItemNo, host);
                }
            }
            window.pwr =
                window.pwr ||
                function () {
                    // eslint-disable-next-line prefer-rest-params
                    (pwr.q = pwr.q || []).push(arguments);
                };
            window.pwr('render', this.reviewSnippetArray);
        }
    }

    buildSnippetArray(itemNo: string, host: string) {
        const config: any = {
            api_key: 'b98bac63-38d8-44ac-9c40-3e650c5439a6',
            locale: 'en_CA',
            merchant_group_id: '12623',
            merchant_id: '3077',
            page_id: itemNo,
            review_wrapper_url: 'https://' + host + '/pages/writereview?pr_page_id=' + itemNo,
            components: {
                CategorySnippet: 'product-reviewsnippet-' + itemNo,
            },
        };
        if (this.isConsentCategoryDisabled('targeting')) {
            config.sm_data = 'DISABLED';
            config.enable_front_end_iovation_validation = false;
        }
        this.reviewSnippetArray.push(config);
    }
static ctorParameters() { return [ { type: TranslateService }, { type: Cookie }, { type: TscAPI } ]; }}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../watchuslive/watchuslive.component.ts